import { useEffect } from 'react';
import { useErrorBoundary } from 'react-error-boundary';

import { StaticError } from 'components/ErrorBoundary';
import { useAppConfig } from 'hooks/appConfig';
import { useConversation } from 'hooks/conversation';
import { ExtensionMessage } from './ExtensionMessage';

import { FormattedMessagesType } from './types';

import TextMessage from 'components/TextMessage';
import { PARTICIPANT_PREFIX } from 'constants/twilio';
import { isLastMessage } from 'utils/twilio';

/**
 * {@linkplain https://lucid.app/lucidchart/f1f35ee6-8b08-439b-920a-eef683d39a72/edit?viewport_loc=-579%2C894%2C2472%2C1282%2C0_0&invitationId=inv_c64e100e-2fef-4a3c-9bf0-d87d0e50fcb2 Reference}
 */
export const ParseFormattedMessage = ({ message }: { message: FormattedMessagesType }) => {
  const { extension, index, author, text } = message;
  const { appConfigState } = useAppConfig();
  const { showBoundary } = useErrorBoundary();
  const { conversationState } = useConversation();

  useEffect(() => {
    if (appConfigState.isDebugMode) {
      console.log(`ChatUi debug - formatted message index #${index}:`, message);
    }
  }, []);

  // TODO - fix margin-bottom on StyledMessageWrapper. Should not apply on last message.
  const isCustomerMsg = author.includes(PARTICIPANT_PREFIX.CUSTOMER);
  const isLastTwilioMsg = isLastMessage(index, conversationState.messages.length);
  const isAnimateMsg = !isCustomerMsg && isLastTwilioMsg && conversationState.isAnimateLastMessage;

  if (!text && !extension) return null;
  if (text && !extension) return <TextMessage message={message} />;
  if (extension) {
    return (
      <ExtensionMessage
        key={index}
        isAnimateMsg={isAnimateMsg}
        isLastTwilioMsg={isLastTwilioMsg}
        extension={extension}
        twilioMessageIndex={index}
      />
    );
  }

  const err = new StaticError(
    `Unknown/incompatible message encountered: ${JSON.stringify(message)}`,
  );
  showBoundary(err);
  return null;
};
